import { styledComponent, Box, Grid } from '@hermes/web-components'

export const VideoWrapper = styledComponent(Box)(() => ({
  width: '265px',
  position: 'relative',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '16px',
  height: '430px',
  overflow: 'hidden',
  border: '1.5px solid transparent',
  cursor: 'pointer',
  span: {
    height: '100% !important',
    img: {
      objectFit: 'cover'
    }
  },

  '& #sub-video-wrapper': {
    transition: 'box-shadow 0.3s ease-in-out'
  },
  '&:hover': {
    '& #sub-video-wrapper': {
      boxShadow: '0px -140px 61px -21px rgba(17,36,90,0.78) inset'
    }
  }
}))

export const ContentWrapper = styledComponent(Grid)({
  flexWrap: 'nowrap',
  padding: '19px 16px',
  paddingTop: '20%',
  justifyContent: 'space-between',
  gap: '50px',

  '@media (max-width: 681px)': {
    flexWrap: 'wrap',
    gap: '10px'
  }
})

export const SubVideoWrapper = styledComponent(Grid)({
  background: 'linear-gradient(180deg, rgba(217, 217, 217, 0) 0%, rgba(13, 12, 14, 0.52) 76.56%)',
  boxShadow: 'inset 0px -69px 57px -21px rgba(17,36,90,0.82)'
})
